import Document, { Html, Head, Main, NextScript } from 'next/document'

import environment from 'environment'

// TODO - removing to see what breaks
// import StyledComponentsManager from 'components/misc/StyledComponentsManager'

import { themes } from 'components/misc/GlobalToolbar/DarkModeToggle'

import { THEME } from 'types/active'
import { ROLES } from 'types/user'

//@ts-ignore
export default class MyDocument extends Document {
  static async getInitialProps(ctx: any) {
    handleSetupCanary(ctx)

    const bodyClass = `${ctx.req.cookies.theme}` === THEME.DARK ? themes.dark.class : themes.light.class

    const tier = ctx.req.cookies.tbTier || 0
    const roles = ctx.req.cookies.tbR || []
    const expiresAt = new Date(ctx.req.cookies.tbFreeTrialExpiresAt || '1999-01-01')
    const now = new Date()

    const adFree =
      roles.includes(ROLES.AD_FREE) ||
      Number(tier) ||
      (environment.nodeEnv === 'development' && !environment.enableAdsOnLocalhost) ||
      now <= expiresAt

    try {
      const initialProps = await Document.getInitialProps(ctx)

      return {
        ...initialProps,
        bodyClass,
        adFree,
        styles: <>{initialProps.styles}</>,
      }
    } catch (err) {
      console.error(err)

      return {
        bodyClass,
        adFree,
      }
    }
  }

  render() {
    return (
      <Html lang="en">
        <Head>
          <meta property="og:site_name" content="Archidekt" />

          <style>
            @import
            url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
            @import url('//cdn.jsdelivr.net/npm/mana-font@latest/css/mana.css'); @import
            url('https://cdnjs.cloudflare.com/ajax/libs/quill/1.2.6/quill.snow.css'); @import
            url('https://cdn.jsdelivr.net/npm/keyrune@latest/css/keyrune.css');
          </style>

          {/* <!-- Smooth scrolling ios - https://github.com/iamdustan/smoothscroll --> */}
          <script defer src="https://unpkg.com/smoothscroll-polyfill@0.4.4/dist/smoothscroll.min.js"></script>

          {/* Ad shit */}
          {/* @ts-ignore */}
          {!this.props.adFree && (
            <script async type="module" src="https://ads.archidekt.com/loader.js" crossOrigin="use-credentials" />
          )}

          {/* Required for the rich text toolbar - could be removed if we made a custom one ourselves for desktop */}
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.2.6/quill.snow.css"
            crossOrigin="anonymous"
          />
        </Head>

        {/* @ts-ignore */}
        <body className={`${this.props.bodyClass} ${!this.props.adFree ? 'ads-enabled' : ''}`}>
          <Main />
          <NextScript />
        </body>
      </Html>
    )
  }
}

export const canaryCookieKey = 'canaryEnabled'
export const canaryVersionKey = 'canaryVersion'

const currentCanaryVersion = '2'
const rolloutPercentage = 0.0

const handleSetupCanary = (ctx: any) => {
  const canaryStatus = ctx.req.cookies[canaryCookieKey]
  const canaryVersion = ctx.req.cookies[canaryVersionKey] || '0'

  const manualCanary = ctx.query.canary
  const randomCanary = Math.random() < rolloutPercentage ? '1' : '0'

  const thirtyDays = new Date(Date.now() + 1000 * 60 * 60 * 24 * 30)

  // If the user manually switches canary versions, let them
  if (manualCanary !== undefined && (manualCanary === '0' || manualCanary === '1')) {
    ctx.res.appendHeader('Set-Cookie', `${canaryCookieKey}=${manualCanary}; Path=/; Expires=${thirtyDays}`)

    return manualCanary === '1'
  }

  // The cookie was already set for them on this version, and they already have a canary status value
  if (canaryVersion === currentCanaryVersion && canaryStatus !== undefined) {
    return canaryStatus === '1'
  }

  ctx.res.appendHeader('Set-Cookie', `${canaryCookieKey}=${randomCanary}; Path=/; Expires=${thirtyDays}`)
  ctx.res.appendHeader('Set-Cookie', `${canaryVersionKey}=${currentCanaryVersion}; Path=/; Expires=${thirtyDays}`)

  return randomCanary === '1'
}
